import { memo, useEffect, useRef } from "react";

import { formatTime } from "../../format";

/**
 * TimeDisplay — "4:03 / 13:22" chip. Written imperatively from `timeupdate`
 * (~4Hz) so the clock never re-renders the React tree.
 */
function TimeDisplay({ videoRef }) {
    const currentRef = useRef(null);
    const durationRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const paintCurrent = () => {
            if (currentRef.current) currentRef.current.textContent = formatTime(video.currentTime);
        };
        const paintDuration = () => {
            if (durationRef.current) durationRef.current.textContent = formatTime(video.duration);
        };

        paintCurrent();
        paintDuration();

        video.addEventListener("timeupdate", paintCurrent);
        video.addEventListener("seeked", paintCurrent);
        video.addEventListener("loadedmetadata", paintDuration);
        video.addEventListener("durationchange", paintDuration);

        return () => {
            video.removeEventListener("timeupdate", paintCurrent);
            video.removeEventListener("seeked", paintCurrent);
            video.removeEventListener("loadedmetadata", paintDuration);
            video.removeEventListener("durationchange", paintDuration);
        };
    }, [videoRef]);

    return (
        <div className="player-chip player-time" onClick={(event) => event.stopPropagation()}>
            <span ref={currentRef}>0:00</span>
            <span className="player-time__separator">/</span>
            <span ref={durationRef}>0:00</span>
        </div>
    );
}

export default memo(TimeDisplay);
